<template>
  <div class="wrapper">
    <div class="content">
      <div class="tableContainer">
        <el-table
          :data="dataList"
          @selection-change="
            (e) => {
              selectList = e;
            }
          "
          border
          style="width: 100%"
          ref="theTable"
          :cell-style="{ padding: '8px 0', fontSize: '14px' }"
        >
          <el-table-column type="selection" width="40px"> </el-table-column>

          <el-table-column prop="userName" label="学员姓名" width="80px">
          </el-table-column>

          <el-table-column
            prop="certificateName"
            label="证书名称"
            width="160px"
          >
          </el-table-column>
          <el-table-column prop="certificateId" label="证书编号" width="240px">
          </el-table-column>
          <el-table-column label="审核状态" width="160px">
            <template slot-scope="{ row }">
              {{
                ["审核中", "默认", "审核通过", "审核不通过"][row.auditStatus]
              }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="申请时间" width="160px">
          </el-table-column>

          <el-table-column align="center" width="400" label="操作">
            <template slot-scope="{ row }">
              <el-button slot="reference" size="small" @click="audit(row)"
                >审核</el-button
              >

              <!-- <el-button
                slot="reference"
                size="small"
                :disabled="row.auditStatus != 1 || row.sealStatus == 1"
                @click="makeSeal(row)"
                >证书盖章</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="getData"
          @size-change="getData"
          :current-page.sync="searchCondition.pageNumber"
          :page-sizes="[10, 30, 100]"
          :page-size.sync="searchCondition.pageSize"
          :total="searchCondition.total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getOneplusxAuditList, oneplusxAudit } from "@/api/certificate.js";
export default {
  data() {
    return {
      searchCondition: {
        pageNumber: 1,
        pageSize: 10,
      },
      dataList: [],
    };
  },
  components: {},
  methods: {
    getData() {
      getOneplusxAuditList(this.searchCondition).then((data) => {
        this.dataList = data.rows;
        console.log(data);
      });
    },
    audit(item) {
      this.$confirm(`请问审核通过吗？`, "提示", {
        confirmButtonText: "通过",
        cancelButtonText: "不通过",
      }).then(
        (res) => {
          oneplusxAudit({
            id: item.id,
            auditStatus: 2,
          }).then((data) => {
            this.$message.success("提交成功");
            this.getData();
          });
        },
        (err) => {
          oneplusxAudit({
            id: item.id,
            auditStatus: 3,
          }).then((data) => {
            this.$message.success("提交成功");
            this.getData();
          });
        }
      );
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .searchBar {
    padding: 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .content {
    margin-top: 15px;
    background: #fff;
    padding: 15px;
    .actBar {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }
  }
}
/deep/ .el-range-editor--small .el-range-input {
  width: 70px;
}
/deep/ .el-date-editor .el-range-separator {
  width: auto;
  padding: 0;
}
</style>
